module.exports = __webpack_public_path__ + "alaska_route_map.a585888.jpg";